import React from 'react';

const variants = {
  primary:
    'bg-ludi-lime text-[#080808] border border-ludi-lime hover:opacity-90 font-bold',
  secondary:
    'bg-transparent text-ludi-emp border border-[var(--ludi-bdr-a)] hover:bg-ludi-lime-d font-semibold',
  ghost: 'bg-transparent text-ludi-t60 border-none hover:text-ludi-t100 font-semibold',
  danger: 'bg-transparent text-red-400 border border-red-400/40 font-semibold',
};

export default function LudiButton({
  variant = 'primary',
  className = '',
  type = 'button',
  disabled,
  children,
  ...props
}) {
  const base =
    'flex items-center justify-center w-full min-h-btn font-ludi text-ludi-base rounded-ludi-md cursor-pointer transition-all tracking-wide disabled:opacity-50 disabled:cursor-not-allowed';
  const ghostSize = variant === 'ghost' ? 'min-h-touch-lg text-ludi-sm' : '';
  return (
    <button
      type={type}
      disabled={disabled}
      className={`${base} ${ghostSize} ${variants[variant] || variants.primary} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
